import { Grid } from '@mantine/core';

interface WidgetData {
    Component: any,
    data: any
}

interface Props {
    widgets: WidgetData[]
}

function WidgetGrid(props: Props) {
    const {widgets} = props;

    return (
        <Grid>
            {widgets.map((w, index) => {
                const {Component, data} = w;
                return <Grid.Col xl={4} key={index}>
                    <Component data={data}></Component>
                </Grid.Col>
            })}
        </Grid>
    )
}

export default WidgetGrid;